/* ==========================================================================
   AIRFORMANCE X · Scratch & Win — v3.0
   Sin checkbox de consentimiento: todo envío se suscribe a la lista.
   Lista elegida por URL (listRoutes) → lista de campaña → lista por defecto.
   ========================================================================== */
(function () {
  'use strict';

  var PREFIX = 'afx_scratch:';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  var KLAVIYO_BASE = 'https://a.klaviyo.com/client/';
  var instances = [];

  function lsGet(k) { try { return window.localStorage.getItem(PREFIX + k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(PREFIX + k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(PREFIX + k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(PREFIX + k, v); } catch (e) {} }
  function objGet(k) { var r = lsGet(k); if (!r) return null; try { return JSON.parse(r); } catch (e) { return null; } }
  function objSet(k, v) { lsSet(k, JSON.stringify(v)); }

  function track(name, data) {
    var payload = { event: name };
    if (data) { Object.keys(data).forEach(function (k) { payload[k] = data[k]; }); }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try { document.dispatchEvent(new CustomEvent('afx:' + name, { detail: payload })); } catch (e) {}
  }

  function normPath(v) {
    v = String(v || '').trim().toLowerCase();
    if (!v) return '';
    v = v.replace(/^https?:\/\/[^/]+/, '');
    v = v.split('#')[0].split('?')[0];
    if (v.charAt(0) !== '/' && v.charAt(0) !== '*') v = '/' + v;
    if (v.length > 1) v = v.replace(/\/+$/, '');
    return v;
  }

  function toRegex(p) {
    return new RegExp('^' + p.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$');
  }

  function currentPaths() {
    var raw = window.location.pathname;
    try { raw = decodeURIComponent(raw); } catch (e) {}
    var p = normPath(raw);
    return [p, p.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/, '') || '/'];
  }

  function matchesAny(patterns) {
    if (!patterns || !patterns.length) return false;
    var paths = currentPaths();
    for (var i = 0; i < patterns.length; i++) {
      var pat = normPath(patterns[i]);
      if (!pat) continue;
      var rx = toRegex(pat);
      if (rx.test(paths[0]) || rx.test(paths[1])) return true;
    }
    return false;
  }

  function pickCampaign(campaigns) {
    var paths = currentPaths();
    var best = null, bestScore = -1;
    campaigns.forEach(function (c) {
      var score = -1;
      if (!c.paths || !c.paths.length) {
        score = 1;
      } else {
        c.paths.forEach(function (raw) {
          var pat = normPath(raw);
          if (!pat) return;
          var rx = toRegex(pat);
          if (rx.test(paths[0]) || rx.test(paths[1])) {
            var s = 100 + pat.length + (pat.indexOf('*') === -1 ? 200 : 0);
            if (s > score) score = s;
          }
        });
      }
      if (score < 0) return;
      score += (c.priority || 0) * 10000;
      if (score > bestScore) { bestScore = score; best = c; }
    });
    return best;
  }

  function pickReward(rewards) {
    var pool = (rewards || []).filter(function (r) { return r.weight > 0; });
    if (!pool.length) return (rewards && rewards[0]) || null;
    var total = pool.reduce(function (s, r) { return s + r.weight; }, 0);
    var roll = Math.random() * total, acc = 0;
    for (var i = 0; i < pool.length; i++) {
      acc += pool[i].weight;
      if (roll < acc) return pool[i];
    }
    return pool[pool.length - 1];
  }

  /* Elige la lista de Klaviyo según la URL actual.
     Cada regla: "patrón|LIST_ID". Gana la más específica. */
  function resolveListId(routes) {
    if (!routes || !routes.length) return '';
    var paths = currentPaths();
    var best = '', bestScore = -1;
    routes.forEach(function (rule) {
      var parts = String(rule).split('|');
      if (parts.length < 2) return;
      var pat = normPath(parts[0]);
      var listId = parts[1].trim();
      if (!pat || !listId) return;
      var rx = toRegex(pat);
      if (rx.test(paths[0]) || rx.test(paths[1])) {
        var score = pat.length + (pat.indexOf('*') === -1 ? 500 : 0);
        if (score > bestScore) { bestScore = score; best = listId; }
      }
    });
    return best;
  }

  function sizedImageUrl(url, width) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) return url;
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function hexToRgb(hex) {
    hex = String(hex || '').replace('#', '').trim();
    if (hex.length === 3) hex = hex.charAt(0)+hex.charAt(0)+hex.charAt(1)+hex.charAt(1)+hex.charAt(2)+hex.charAt(2);
    if (!/^[0-9a-f]{6}$/i.test(hex)) return { r: 170, g: 173, b: 179 };
    return { r: parseInt(hex.slice(0,2),16), g: parseInt(hex.slice(2,4),16), b: parseInt(hex.slice(4,6),16) };
  }

  function mix(a, b, t) {
    var A = hexToRgb(a), B = hexToRgb(b);
    return 'rgb(' + Math.round(A.r+(B.r-A.r)*t) + ',' + Math.round(A.g+(B.g-A.g)*t) + ',' + Math.round(A.b+(B.b-A.b)*t) + ')';
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ------------------------------ Klaviyo ------------------------------ */
  function klaviyoPost(endpoint, companyId, revision, body) {
    return fetch(KLAVIYO_BASE + endpoint + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': revision || '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.ok) return true;
      return res.text().then(function (t) { throw new Error('Klaviyo ' + res.status + ' — ' + t); });
    });
  }

  function sendToKlaviyo(kl, payload) {
    if (!kl || !kl.companyId) {
      console.warn('[AFX Scratch] Klaviyo sin configurar.', payload);
      return Promise.reject(new Error('klaviyo_not_configured'));
    }

    var props = {
      scratch_reward_name: payload.rewardName,
      scratch_reward_code: payload.rewardCode,
      scratch_campaign_id: payload.campaignId,
      scratch_landing_path: payload.path,
      scratch_date: payload.date,
      source: 'scratch_popup',
      campaign: payload.campaignTag
    };
    if (kl.segmentProperty) props[kl.segmentProperty] = kl.segmentValue || 'active';

    var listId = payload.listId || kl.defaultListId;
    var chain;

    if (listId) {
      /* El endpoint /client/subscriptions/ NO acepta el objeto 'subscriptions'.
         El consentimiento va implícito en la propia llamada. */
      chain = klaviyoPost('subscriptions/', kl.companyId, kl.revision, {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'AIRFORMANCE X Scratch Popup',
            profile: { data: { type: 'profile', attributes: {
              email: payload.email,
              properties: props
            } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      });
    } else {
      console.warn('[AFX Scratch] Sin lista configurada; solo se crea el perfil.');
      chain = klaviyoPost('profiles/', kl.companyId, kl.revision, {
        data: { type: 'profile', attributes: { email: payload.email, properties: props } }
      });
    }

    return chain.then(function () {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        try { window.klaviyo.identify({ $email: payload.email }); } catch (e) {}
      }
      if (!kl.metricName) return true;
      return klaviyoPost('events/', kl.companyId, kl.revision, {
        data: { type: 'event', attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: kl.metricName } } },
          profile: { data: { type: 'profile', attributes: { email: payload.email } } }
        } }
      }).catch(function (e) { console.warn('[AFX Scratch] Evento no registrado:', e); return true; });
    });
  }

  function queuePush(p) {
    var q = objGet('queue') || [];
    q.push(p);
    if (q.length > 20) q = q.slice(-20);
    objSet('queue', q);
  }

  function queueFlush(kl) {
    var q = objGet('queue');
    if (!q || !q.length || !kl.companyId) return;
    objSet('queue', []);
    q.forEach(function (item) {
      sendToKlaviyo(kl, item).catch(function () { queuePush(item); });
    });
  }

  /* ============================== Controller ============================ */
  function createController(root) {
    var configEl = root.querySelector('script[data-afx-config]');
    if (!configEl) return null;

    var config;
    try { config = JSON.parse(configEl.textContent); }
    catch (e) { console.error('[AFX Scratch] Config inválida', e); return null; }

    var S = config.settings;
    var KL = config.klaviyo;

    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var forcePreview = /[?&]afx_preview=1/.test(window.location.search);

    if (!designMode && !forcePreview && matchesAny(S.excludePaths)) return null;

    var campaign = pickCampaign(config.campaigns || []);
    if (!campaign || !campaign.rewards || !campaign.rewards.length) return null;

    var sectionId = root.getAttribute('data-section-id');
    var stateKey = 'state:' + campaign.id;

    if (window.matchMedia('(max-width: 859px)').matches && !S.enableOnMobile && !designMode && !forcePreview) return null;

    var dialog     = root.querySelector('[data-afx-dialog]');
    var overlay    = root.querySelector('[data-afx-overlay]');
    var closeBtn   = root.querySelector('[data-afx-close]');
    var mediaEl    = root.querySelector('[data-afx-media]');
    var imageEl    = root.querySelector('[data-afx-image]');
    var logoEl     = root.querySelector('[data-afx-logo]');
    var logoWrap   = root.querySelector('[data-afx-logo-wrap]');
    var logoTextEl = root.querySelector('[data-afx-logo-text]');
    var eyebrowEl  = root.querySelector('[data-afx-eyebrow]');
    var card       = root.querySelector('[data-afx-card]');
    var canvas     = root.querySelector('[data-afx-canvas]');
    var prizeValue = root.querySelector('[data-afx-prize-value]');
    var revealBtn  = root.querySelector('[data-afx-reveal]');
    var winValue   = root.querySelector('[data-afx-win-value]');
    var form       = root.querySelector('[data-afx-form]');
    var emailInput = root.querySelector('[data-afx-email]');
    var errorEl    = root.querySelector('[data-afx-error]');
    var submitBtn  = root.querySelector('[data-afx-submit]');
    var codeBtn    = root.querySelector('[data-afx-copy]');
    var codeValue  = root.querySelector('[data-afx-code-value]');
    var copiedEl   = root.querySelector('[data-afx-copied]');
    var shopBtn    = root.querySelector('[data-afx-shop]');
    var steps      = Array.prototype.slice.call(root.querySelectorAll('[data-afx-step]'));

    var state = 'CLOSED';
    var reward = null;
    var revealed = false;
    var scratching = false;
    var scratchStarted = false;
    var imageLoaded = false;
    var discountRequested = false;
    var ctx = null;
    var cssW = 0, cssH = 0, dpr = 1;
    var lastPoint = null;
    var moveCount = 0;
    var previousFocus = null;
    var scrollY = 0;
    var timers = [];
    var teardown = [];
    var ro = null;

    function on(t, type, fn, opts) {
      t.addEventListener(type, fn, opts);
      teardown.push(function () { t.removeEventListener(type, fn, opts); });
    }
    function later(fn, ms) { var id = window.setTimeout(fn, ms); timers.push(id); return id; }

    function neutralizeCta(el) {
      if (!el) return;
      if (el.tagName === 'A') {
        el.removeAttribute('href');
        el.removeAttribute('target');
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.style.cursor = 'pointer';
      }
    }
    neutralizeCta(shopBtn);

    /* --------------------------- Persistencia -------------------------- */
    function loadState() {
      var st = objGet(stateKey);
      if (!st || !st.rewardId) return null;
      var still = campaign.rewards.filter(function (r) { return r.id === st.rewardId; })[0];
      if (!still) return null;
      st.reward = still;
      return st;
    }
    function saveState(patch) {
      var st = objGet(stateKey) || {};
      Object.keys(patch).forEach(function (k) { st[k] = patch[k]; });
      objSet(stateKey, st);
    }
    function ensureReward() {
      if (reward) return reward;
      var st = loadState();
      if (st && st.reward) { reward = st.reward; return reward; }
      reward = pickReward(campaign.rewards);
      saveState({ rewardId: reward.id, code: reward.code, ts: Date.now(), unlocked: false, emailSent: false });
      return reward;
    }
    function shouldShow() {
      if (designMode || forcePreview) return true;
      if (ssGet('closed') === '1') return false;
      var st = objGet(stateKey);
      if (S.oncePerUser && st && st.rewardId) return false;
      if (st && st.unlocked) return false;
      var last = parseInt(lsGet('shown') || '0', 10);
      if (S.frequencyDays > 0 && last && (Date.now() - last) < S.frequencyDays * 86400000) return false;
      return true;
    }

    /* ------------------------------ Render ----------------------------- */
    function applyCampaign() {
      var c = campaign.colors;
      root.style.setProperty('--afx-bg', c.bg);
      root.style.setProperty('--afx-text', c.text);
      root.style.setProperty('--afx-accent', c.accent);
      root.style.setProperty('--afx-btn-text', c.btnText);
      root.style.setProperty('--afx-radius', campaign.radius + 'px');
      root.style.setProperty('--afx-max-width', campaign.maxWidth + 'px');
      root.style.setProperty('--afx-logo-width', (campaign.logoMaxWidth || 230) + 'px');
      root.style.setProperty('--afx-logo-ratio', String(campaign.logoRatio || 5));

      mediaEl.classList.toggle('is-grayscale', !!campaign.imageGrayscale);

      if (campaign.logo) {
        logoEl.src = sizedImageUrl(campaign.logo, 700);
        logoEl.alt = campaign.logoText || 'AIRFORMANCE X';
        if (logoWrap) logoWrap.hidden = false; else logoEl.hidden = false;
        logoTextEl.textContent = '';
        logoEl.onerror = function () {
          if (logoWrap) logoWrap.hidden = true; else logoEl.hidden = true;
          logoTextEl.textContent = campaign.logoText || 'AIRFORMANCE X';
        };
      } else {
        if (logoWrap) logoWrap.hidden = true; else logoEl.hidden = true;
        logoTextEl.textContent = campaign.logoText || '';
      }

      eyebrowEl.textContent = campaign.eyebrow || '';
      root.querySelector('[data-afx-headline]').textContent = campaign.headline || '';
      root.querySelector('[data-afx-sub]').textContent = campaign.subheadline || '';
      root.querySelector('[data-afx-email-intro]').textContent = campaign.emailIntro || '';
      root.querySelector('[data-afx-success-headline]').textContent = campaign.successHeadline || '';
      root.querySelector('[data-afx-success-sub]').textContent = campaign.successSub || '';
      root.querySelector('[data-afx-submit-text]').textContent = campaign.ctaEmail || '';
      root.querySelector('[data-afx-shop-text]').textContent = campaign.closeCta || 'SEGUIR COMPRANDO';
      root.querySelector('[data-afx-privacy]').innerHTML = campaign.privacyHtml || '';

      emailInput.placeholder = campaign.emailPlaceholder || '';
      codeBtn.setAttribute('aria-label', campaign.copyButton || 'Copiar código');
    }

    function loadImage() {
      if (imageLoaded || !campaign.image) return;
      imageLoaded = true;
      imageEl.src = sizedImageUrl(campaign.image, 1200);
      imageEl.alt = campaign.imageAlt || '';
    }

    /* ------------------------------ Canvas ----------------------------- */
    function drawTrackedText(text, cx, cy, size, tracking) {
      ctx.font = '700 ' + size + 'px ' + getComputedStyle(root).fontFamily;
      ctx.textBaseline = 'middle';
      var chars = String(text).split('');
      var widths = chars.map(function (ch) { return ctx.measureText(ch).width; });
      var total = widths.reduce(function (a, b) { return a + b; }, 0) + tracking * (chars.length - 1);
      var x = cx - total / 2;
      ctx.textAlign = 'left';
      chars.forEach(function (ch, i) { ctx.fillText(ch, x, cy); x += widths[i] + tracking; });
    }

    function paintOverlay() {
      var w = cssW, h = cssH;
      var c1 = campaign.colors.scratch1, c2 = campaign.colors.scratch2;

      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, w, h);

      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0.00, mix(c1, '#ffffff', 0.14));
      g.addColorStop(0.30, c1);
      g.addColorStop(0.50, mix(c1, '#ffffff', 0.34));
      g.addColorStop(0.70, c2);
      g.addColorStop(1.00, mix(c2, '#000000', 0.18));
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      ctx.save();
      ctx.globalAlpha = 0.09;
      ctx.fillStyle = '#ffffff';
      ctx.translate(w * 0.2, 0);
      ctx.rotate(-0.42);
      ctx.fillRect(-w, 0, w * 0.2, h * 2.4);
      ctx.fillRect(w * 0.34, 0, w * 0.08, h * 2.4);
      ctx.restore();

      ctx.save();
      var dots = Math.min(1200, Math.round(w * h / 130));
      for (var i = 0; i < dots; i++) {
        ctx.globalAlpha = Math.random() * 0.06;
        ctx.fillStyle = Math.random() > 0.5 ? '#ffffff' : '#000000';
        ctx.fillRect(Math.random() * w, Math.random() * h, 1.2, 1.2);
      }
      ctx.restore();

      ctx.save();
      ctx.globalAlpha = 1;
      ctx.shadowColor = 'rgba(0,0,0,.28)';
      ctx.shadowBlur = 6;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = campaign.colors.scratchText;
      var size = Math.max(13, Math.min(19, Math.round(w * 0.055)));
      drawTrackedText(campaign.scratchText || 'RASCA AQUÍ', w / 2, h / 2, size, size * 0.2);
      ctx.restore();

      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
    }

    function initCanvas() {
      var rect = card.getBoundingClientRect();
      if (rect.width < 8 || rect.height < 8) return false;

      cssW = rect.width;
      cssH = rect.height;
      dpr = Math.min(window.devicePixelRatio || 1, 2);

      canvas.width = Math.max(1, Math.round(cssW * dpr));
      canvas.height = Math.max(1, Math.round(cssH * dpr));

      var c = null;
      try { c = canvas.getContext('2d', { willReadFrequently: true }) || canvas.getContext('2d'); }
      catch (e) { c = null; }
      if (!c) return false;

      ctx = c;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      paintOverlay();
      return true;
    }

    function eventPoint(e) {
      var src = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
      var rect = canvas.getBoundingClientRect();
      return { x: src.clientX - rect.left, y: src.clientY - rect.top };
    }

    function scratchTo(p) {
      var radius = Math.max(20, cssW * 0.078);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.globalAlpha = 1;
      ctx.strokeStyle = 'rgba(0,0,0,1)';
      ctx.fillStyle = 'rgba(0,0,0,1)';
      ctx.lineWidth = radius * 2;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      if (lastPoint) {
        ctx.beginPath();
        ctx.moveTo(lastPoint.x, lastPoint.y);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(p.x, p.y, radius, 0, Math.PI * 2);
      ctx.fill();
      lastPoint = p;
    }

    function progress() {
      if (!ctx || !canvas.width || !canvas.height) return 0;
      var data;
      try { data = ctx.getImageData(0, 0, canvas.width, canvas.height).data; }
      catch (e) { return 100; }
      var stride = 4 * 24, total = 0, clear = 0;
      for (var i = 3; i < data.length; i += stride) {
        total++;
        if (data[i] < 40) clear++;
      }
      return total ? (clear / total) * 100 : 0;
    }

    function onDown(e) {
      if (revealed) return;
      if (!ctx && !initCanvas()) { doReveal(false); return; }
      if (e.cancelable) e.preventDefault();

      scratching = true;
      lastPoint = null;
      card.classList.remove('is-idle');

      if (e.pointerId != null && canvas.setPointerCapture) {
        try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (!scratchStarted) {
        scratchStarted = true;
        state = 'SCRATCHING';
        track('scratch_started', { campaign_id: campaign.id, campaign: S.campaignTag });
      }
      scratchTo(eventPoint(e));
    }

    function onMove(e) {
      if (!scratching || revealed || !ctx) return;
      if (e.cancelable) e.preventDefault();
      scratchTo(eventPoint(e));
      moveCount++;
      if (moveCount % 5 === 0 && progress() >= S.scratchThreshold) doReveal(true);
    }

    function onUp(e) {
      if (!scratching) return;
      scratching = false;
      lastPoint = null;
      if (e && e.pointerId != null && canvas.releasePointerCapture) {
        try { canvas.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      if (!revealed && progress() >= S.scratchThreshold) doReveal(true);
    }

    function bindScratchInput() {
      if (window.PointerEvent) {
        on(canvas, 'pointerdown', onDown);
        on(window, 'pointermove', onMove, { passive: false });
        on(window, 'pointerup', onUp);
        on(window, 'pointercancel', onUp);
      } else {
        on(canvas, 'mousedown', onDown);
        on(window, 'mousemove', onMove);
        on(window, 'mouseup', onUp);
        on(canvas, 'touchstart', onDown, { passive: false });
        on(window, 'touchmove', onMove, { passive: false });
        on(window, 'touchend', onUp);
        on(window, 'touchcancel', onUp);
      }
      on(canvas, 'contextmenu', function (e) { e.preventDefault(); });
      on(canvas, 'dragstart', function (e) { e.preventDefault(); });
    }

    function doReveal(fromScratch) {
      if (revealed) return;
      revealed = true;
      state = 'REVEALED';
      card.classList.remove('is-idle');
      card.classList.add('is-revealed');
      canvas.style.pointerEvents = 'none';
      revealBtn.hidden = true;

      track('scratch_completed', {
        campaign_id: campaign.id, campaign: S.campaignTag,
        reward: reward.name, method: fromScratch ? 'scratch' : 'button'
      });

      later(function () { setStep('email'); }, reducedMotion() ? 0 : 1000);
    }

    /* ------------------- Descuento sin navegación ---------------------- */
    function applyDiscountSilently(code, force) {
      if (!S.preapplyDiscount || !code) return;
      if (discountRequested && !force) return;
      discountRequested = true;

      var base = (S.rootUrl || '/').replace(/\/+$/, '');
      var url = base + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js');

      function viaIframe() {
        try {
          var frame = document.createElement('iframe');
          frame.setAttribute('aria-hidden', 'true');
          frame.setAttribute('tabindex', '-1');
          frame.setAttribute('title', '');
          frame.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none;';
          frame.src = url;
          document.body.appendChild(frame);
          window.setTimeout(function () {
            if (frame.parentNode) frame.parentNode.removeChild(frame);
          }, 8000);
          track('discount_applied', { campaign_id: campaign.id, campaign: S.campaignTag, coupon: code, method: 'iframe' });
        } catch (e) {
          console.warn('[AFX Scratch] No se pudo aplicar el descuento automáticamente:', e);
        }
      }

      fetch(url, { method: 'GET', credentials: 'same-origin', redirect: 'follow', cache: 'no-store' })
        .then(function () {
          track('discount_applied', { campaign_id: campaign.id, campaign: S.campaignTag, coupon: code, method: 'fetch' });
        })
        .catch(viaIframe);
    }

    /* ------------------------------ Pasos ------------------------------ */
    function setStep(name) {
      steps.forEach(function (el) {
        var active = el.getAttribute('data-afx-step') === name;
        el.hidden = !active;
        el.classList.toggle('is-active', active);
      });
      var ids = { scratch: 'afx-title-', email: 'afx-title-email-', unlocked: 'afx-title-unlocked-' };
      dialog.setAttribute('aria-labelledby', ids[name] + sectionId);

      if (name === 'email') {
        state = 'EMAIL_REQUIRED';
        winValue.textContent = reward.display;
        later(function () { try { emailInput.focus({ preventScroll: true }); } catch (e) {} }, 60);
      } else if (name === 'unlocked') {
        state = 'UNLOCKED';
        codeValue.textContent = reward.code;
        if (shopBtn.tagName === 'BUTTON') shopBtn.disabled = false;
        var sub = root.querySelector('[data-afx-reward-subtitle]');
        if (reward.subtitle) { sub.textContent = reward.subtitle; sub.hidden = false; }
        applyDiscountSilently(reward.code);
        later(function () { try { codeBtn.focus({ preventScroll: true }); } catch (e) {} }, 60);
      }
    }

    /* ------------------------------ Email ------------------------------ */
    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
      emailInput.classList.add('has-error');
      emailInput.setAttribute('aria-invalid', 'true');
    }
    function clearError() {
      errorEl.hidden = true;
      emailInput.classList.remove('has-error');
      emailInput.removeAttribute('aria-invalid');
    }

    function onSubmit(e) {
      e.preventDefault();
      clearError();

      var email = (emailInput.value || '').trim();
      if (!EMAIL_RE.test(email)) { showError('Introduce un email válido.'); emailInput.focus(); return; }

      submitBtn.disabled = true;
      submitBtn.querySelector('[data-afx-submit-text]').textContent = 'ENVIANDO…';

      var payload = {
        email: email,
        rewardName: reward.name, rewardCode: reward.code,
        campaignId: campaign.id, campaignTag: S.campaignTag,
        listId: resolveListId(S.listRoutes) || campaign.klaviyoListId || '',
        path: window.location.pathname, date: new Date().toISOString()
      };

      track('email_submitted', {
        campaign_id: campaign.id, campaign: S.campaignTag,
        reward: reward.name, klaviyo_list: payload.listId || KL.defaultListId
      });

      function unlock(ok) {
        saveState({ emailSent: true, unlocked: true, email: email, unlockedTs: Date.now() });
        lsSet('shown', String(Date.now()));
        submitBtn.disabled = false;
        submitBtn.querySelector('[data-afx-submit-text]').textContent = campaign.ctaEmail || '';
        setStep('unlocked');
        track('reward_unlocked', {
          campaign_id: campaign.id, campaign: S.campaignTag,
          reward: reward.name, coupon: reward.code, crm_sync: ok,
          klaviyo_list: payload.listId || KL.defaultListId
        });
      }

      sendToKlaviyo(KL, payload)
        .then(function () { unlock(true); })
        .catch(function (err) {
          console.warn('[AFX Scratch] Klaviyo falló, se reintentará:', err);
          queuePush(payload);
          unlock(false);
        });
    }

    /* ------------------------------ Copiar ----------------------------- */
    function copyCode() {
      var text = reward.code;
      function done() {
        copiedEl.hidden = false;
        later(function () { copiedEl.hidden = true; }, 2200);
        track('coupon_copied', { campaign_id: campaign.id, campaign: S.campaignTag, coupon: text });
      }
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(fallback);
      } else { fallback(); }
    }

    /* --------------------------- Abrir/cerrar -------------------------- */
    function focusables() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; }
      );
    }

    function onKeydown(e) {
      if (state === 'CLOSED') return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function lockScroll() {
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY + 'px';
      document.body.style.width = '100%';
      document.body.classList.add('afx-scratch-locked');
    }
    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.classList.remove('afx-scratch-locked');
      window.scrollTo(0, scrollY);
    }

    function prepareCanvasWhenVisible(attempt) {
      attempt = attempt || 0;
      if (revealed || state === 'CLOSED') return;
      if (initCanvas()) {
        if (!reducedMotion()) card.classList.add('is-idle');
        return;
      }
      if (attempt < 12) later(function () { prepareCanvasWhenVisible(attempt + 1); }, 80);
      else console.warn('[AFX Scratch] Canvas sin dimensiones; usa el enlace de revelar.');
    }

    function open(source) {
      if (state !== 'CLOSED') return;
      ensureReward();
      prizeValue.textContent = reward.display;

      var st = objGet(stateKey);
      previousFocus = document.activeElement;
      loadImage();
      root.hidden = false;
      void root.offsetHeight;
      root.classList.add('is-open');
      lockScroll();
      state = 'OPEN';

      if (st && st.unlocked) {
        revealed = true;
        card.classList.add('is-revealed');
        revealBtn.hidden = true;
        setStep('unlocked');
      } else {
        setStep('scratch');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { prepareCanvasWhenVisible(0); });
        });
      }

      later(function () { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }, 120);
      if (!designMode) lsSet('shown', String(Date.now()));

      track('scratch_popup_viewed', {
        campaign_id: campaign.id, campaign: S.campaignTag, trigger: source || 'auto'
      });
    }

    function close(source) {
      if (state === 'CLOSED') return;
      var was = state;
      root.classList.remove('is-open');
      unlockScroll();
      state = 'CLOSED';
      later(function () { root.hidden = true; }, reducedMotion() ? 0 : 340);
      if (!designMode) ssSet('closed', '1');
      if (previousFocus && previousFocus.focus) {
        try { previousFocus.focus({ preventScroll: true }); } catch (e) {}
      }
      track('scratch_popup_closed', {
        campaign_id: campaign.id, campaign: S.campaignTag, from_state: was, method: source || 'x'
      });
    }

    /* ------------------------------ Triggers --------------------------- */
    function setupTriggers() {
      if (designMode) { if (S.openInEditor) later(function () { open('editor'); }, 400); return; }
      if (forcePreview) { later(function () { open('preview_param'); }, 300); return; }
      if (!shouldShow()) return;

      var fired = false;
      function fire(src) { if (!fired && shouldShow()) { fired = true; open(src); } }

      if (S.delaySeconds >= 0) later(function () { fire('delay'); }, S.delaySeconds * 1000);

      if (S.enableScrollTrigger) {
        var onScroll = function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          if (h <= 0) return;
          var pct = ((window.pageYOffset || document.documentElement.scrollTop) / h) * 100;
          if (pct >= S.scrollPercentage) { fire('scroll'); window.removeEventListener('scroll', onScroll); }
        };
        on(window, 'scroll', onScroll, { passive: true });
      }

      if (S.enableExitIntent && window.matchMedia('(min-width: 860px)').matches && !('ontouchstart' in window)) {
        on(document, 'mouseout', function (e) {
          if (e.clientY <= 0 && !e.relatedTarget) fire('exit_intent');
        });
      }
    }

    /* ------------------------------ Wiring ----------------------------- */
    applyCampaign();
    bindScratchInput();

    on(closeBtn, 'click', function () { close('x'); });
    on(overlay, 'click', function () { if (S.closeOnOverlay) close('overlay'); });
    on(document, 'keydown', onKeydown);

    on(revealBtn, 'click', function () { doReveal(false); });
    on(form, 'submit', onSubmit);
    on(emailInput, 'input', clearError);
    on(codeBtn, 'click', copyCode);

    on(shopBtn, 'click', function () {
      if (shopBtn.disabled) return;
      shopBtn.disabled = true;
      applyDiscountSilently(reward.code, true);
      copyCode();
      saveState({ converted: true });
      track('cta_clicked', {
        campaign_id: campaign.id, campaign: S.campaignTag,
        reward: reward ? reward.name : '', coupon: reward ? reward.code : '',
        action: 'copy_and_close'
      });
      later(function () { close('cta'); }, 850);
    });

    if (window.ResizeObserver) {
      ro = new ResizeObserver(function (entries) {
        if (state === 'CLOSED' || revealed || scratchStarted) return;
        var r = entries[0] && entries[0].contentRect;
        if (!r || r.width < 8) return;
        if (Math.abs(r.width - cssW) < 2 && Math.abs(r.height - cssH) < 2) return;
        initCanvas();
      });
      ro.observe(card);
      teardown.push(function () { try { ro.disconnect(); } catch (e) {} });
    }

    on(document, 'click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-afx-scratch-open], a[href="#afx-scratch"]') : null;
      if (!trigger) return;
      e.preventDefault();
      if (state === 'CLOSED') open('manual');
    });

    queueFlush(KL);
    setupTriggers();

    return {
      root: root, open: open, close: close,
      debug: function () {
        return {
          campaign: campaign.id,
          reward: reward,
          state: state,
          listRoutes: S.listRoutes,
          listaQueSeUsaria: resolveListId(S.listRoutes) || campaign.klaviyoListId || KL.defaultListId,
          path: currentPaths()
        };
      },
      destroy: function () {
        timers.forEach(window.clearTimeout);
        teardown.forEach(function (fn) { fn(); });
        if (state !== 'CLOSED') unlockScroll();
        state = 'CLOSED';
      }
    };
  }

  /* ------------------------------ Bootstrap ---------------------------- */
  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-afx-scratch]');
    Array.prototype.forEach.call(nodes, function (root) {
      if (root.__afxInit) return;
      var ctrl = createController(root);
      if (!ctrl) return;
      root.__afxInit = ctrl;
      instances.push(ctrl);
    });
  }

  function destroyIn(scope) {
    var nodes = (scope || document).querySelectorAll('[data-afx-scratch]');
    Array.prototype.forEach.call(nodes, function (root) {
      if (!root.__afxInit) return;
      root.__afxInit.destroy();
      instances = instances.filter(function (i) { return i !== root.__afxInit; });
      root.__afxInit = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyIn(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var r = e.target.querySelector('[data-afx-scratch]');
    if (r && r.__afxInit) r.__afxInit.open('editor_select');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var r = e.target.querySelector('[data-afx-scratch]');
    if (r && r.__afxInit) r.__afxInit.close('editor_deselect');
  });

  window.AFXScratch = {
    instances: function () { return instances.slice(); },
    debug: function () { return instances.map(function (i) { return i.debug(); }); },
    open: function () { if (instances[0]) instances[0].open('api'); },
    close: function () { if (instances[0]) instances[0].close('api'); },
    reset: function () {
      try {
        Object.keys(window.localStorage).filter(function (k) { return k.indexOf(PREFIX) === 0; })
          .forEach(function (k) { window.localStorage.removeItem(k); });
        Object.keys(window.sessionStorage).filter(function (k) { return k.indexOf(PREFIX) === 0; })
          .forEach(function (k) { window.sessionStorage.removeItem(k); });
      } catch (e) {}
      console.log('[AFX Scratch] Estado reiniciado. Recarga la página.');
    }
  };
})();